// Languages CometQR can show diners — mirror of the customer app's i18n/languages.js so the owner's
// picker and the customer menu switcher agree. Menu text is stored per item in the flexible
// `translations` map, so any language here works as soon as the owner types it (no schema change).
const MASTER_LANGS = [
  { code: 'en', label: 'English', flag: '🇺🇸' }, // English shown with the US flag (Rajat's call)
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'th', label: 'ไทย', flag: '🇹🇭' },
  { code: 'km', label: 'ភាសាខ្មែរ', flag: '🇰🇭' },
  { code: 'lo', label: 'ພາសາລាວ', flag: '🇱🇦' },
  { code: 'ms', label: 'Bahasa Melayu', flag: '🇲🇾' },
  { code: 'ru', label: 'Русский', flag: '🇷🇺' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', label: 'Português', flag: '🇵🇹' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦' },
  { code: 'zh', label: '中文', flag: '🇨🇳' },
  { code: 'hi', label: 'हिन्दी', flag: '🇮🇳' },
  { code: 'uz', label: 'Oʻzbekcha', flag: '🇺🇿' },
];

export const MASTER_CODES = MASTER_LANGS.map((l) => l.code);

// Flag emoji for a language code (falls back to a globe). English = US flag.
export function langFlag(code) {
  const m = MASTER_LANGS.find((l) => l.code === code);
  return (m && m.flag) || '🌐';
}
export const LEGACY_DEFAULT = ['en', 'th', 'ru'];

// Parse a venue's diner_languages CSV → ordered codes (primary first); legacy en/th/ru when unset.
export function venueLangCodes(dinerLanguages) {
  if (!dinerLanguages || typeof dinerLanguages !== 'string') return LEGACY_DEFAULT;
  const codes = dinerLanguages
    .split(',')
    .map((s) => s.trim().toLowerCase())
    .filter((c) => MASTER_CODES.includes(c));
  return codes.length ? codes : LEGACY_DEFAULT;
}

// { code: label } map of the languages a venue's menu editor should offer (English always present).
// Drives the per-language translation inputs in the dish + category editors.
export function supportedLangsForVenue(venue) {
  const out = {};
  for (const c of venueLangCodes(venue && venue.diner_languages)) {
    const m = MASTER_LANGS.find((l) => l.code === c);
    if (m) out[c] = m.label;
  }
  if (!out.en) out.en = 'English';
  return out;
}

export default MASTER_LANGS;
